module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/special/notes/notes.component.less
// module id = ./src/app/special/notes/notes.component.less
// module chunks = main